import { lazy } from "react";

export const LazyQuestionPage = lazy(async () => ({
    default: (await import("./QuestionPage")).QuestionPage
}));

export const LazyWhyAreWeAsking = lazy(async () => ({
    default: (await import("./WhyAreWeAsking")).WhyAreWeAsking
}));
